export enum FloorActivityMemeId {
    Again = 'again',
    Back = 'back',
    Darkness = 'darkness',
    Dead = 'dead',
    Devs = 'devs',
    Pour = 'pour',
    What = 'what',
}

interface FloorActivityMemeData {
    labelKey: string;
    image: string;
}

export type FloorActivityMemeCollection = {
    [key in FloorActivityMemeId]: FloorActivityMemeData;
};
